import createStateReducer from "../../helpers/createStateReducer";
import states from "../../states/sharedDownloadStates";
import deltas from "../../actions/deltas";

const {SET_DOWNLOAD_ENROLMENTS_CSV_STATE} = deltas.actionTypes;

export default createStateReducer(states, null, SET_DOWNLOAD_ENROLMENTS_CSV_STATE);

export const selectIsLoadingDownloadEnrolmentsCsv = (state) => states.LOADING === state.states.downloadEnrolmentsCsv.state;
